import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material"

export interface ResetLayoutConfirmDialogProps {
  open: boolean
  onClose: () => void
  // Confirms the reset. The menu requests the reset and closes the dialog.
  onConfirm: () => void
}

// Confirmation gate for Reset: re-seeding from the saved layout discards the current arrangement.
export default function ResetLayoutConfirmDialog({ open, onClose, onConfirm }: ResetLayoutConfirmDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <DialogTitle>Reset this dashboard&apos;s layout?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Your current panel arrangement will be discarded and the saved layout restored. This
          can&apos;t be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} color="error" variant="contained">Reset layout</Button>
      </DialogActions>
    </Dialog>
  )
}
